
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AdminHeaderService } from '../services/admin.header.service';

import * as _ from 'lodash-es';

@Component({
    selector: 'admin-heading-dropdown',
    template: require('./admin.heading-dropdown.component.html')
})
export class AdminHeadingDropdownComponent implements OnInit, OnChanges {

    @Input() currentState: any;

    protected menuData: any;
    protected currentGlyph: string;

    constructor(
        private adminHeaderService: AdminHeaderService
    ) { }
    
    ngOnInit() {
        this.menuData = this.adminHeaderService.getMenuData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.currentGlyph = this.adminHeaderService.getGlyphForState(
            _.get(changes, 'currentState.currentValue', 'home.admin')
        );
    }
}